import React from 'react';
import { Anchor, Breadcrumbs, Paper, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useAppContext } from '../contexts/AppContext';

const VOLGORDE = ['nederland', 'regio', 'gemeente', 'buurt', 'project'];

// Klikbaar navigatiepad (kruimelpad): Nederland › Regio › Gemeente › Buurt › Station.
// Dit is de zichtbare manier om een niveau af te sluiten — naast rechtsklikken.
export default function NavigatiePad() {
  const { level, navigatie, drillDown, selectedProject, setSelectedProject } = useAppContext();
  // Op smalle schermen (tablet) botst het gecentreerde pad met de zoekbalk:
  // dan een regel lager, onder de zoekbalk.
  const smalScherm = useMediaQuery('(max-width: 900px)');

  if (!navigatie) return null;
  const huidigeIndex = VOLGORDE.indexOf(level);

  const stappen = [{ label: 'Nederland', niveau: 'nederland', feature: null }];

  const regio = navigatie.regio?.current;
  if (regio && huidigeIndex >= 1) {
    stappen.push({ label: regio.properties.regio, niveau: 'regio', feature: regio });
  }
  const gemeente = navigatie.gemeente?.current;
  if (gemeente && huidigeIndex >= 2) {
    stappen.push({ label: gemeente.properties.gemeentenaam, niveau: 'gemeente', feature: gemeente });
  }
  const buurt = navigatie.buurt?.current;
  if (buurt && huidigeIndex >= 3) {
    stappen.push({ label: buurt.properties.buurtnaam || buurt.properties.buurtcode, niveau: 'buurt', feature: buurt });
  }
  if (level === 'project' && selectedProject) {
    stappen.push({ label: selectedProject.projectnummer, niveau: 'project', feature: null });
  }

  if (stappen.length === 1 && level === 'nederland') return null;

  const naarNiveau = (stap) => {
    if (stap.niveau === level && stap.niveau !== 'buurt') return;
    if (stap.niveau === 'buurt') {
      // Buurt aanklikken vanaf projectniveau = station afsluiten (deselectie-event
      // volgt automatisch); vanaf buurtniveau doet het niets schadelijks.
      setSelectedProject(null);
      drillDown({ targetLevel: 'buurt', feature: stap.feature });
    } else if (stap.niveau === 'nederland') {
      setSelectedProject(null);
      drillDown({ targetLevel: 'nederland' });
    } else {
      setSelectedProject(null);
      drillDown({ targetLevel: stap.niveau, feature: stap.feature });
    }
  };

  return (
    <Paper
      shadow="sm" radius="xl" withBorder px="md" py={6}
      style={smalScherm ? {
        position: 'absolute', top: 62, left: 76,
        zIndex: 9, maxWidth: 'calc(100vw - 140px)', overflow: 'hidden', whiteSpace: 'nowrap',
      } : {
        position: 'absolute', top: 12, left: '50%', transform: 'translateX(-50%)',
        zIndex: 9, maxWidth: 'min(60vw, 700px)', overflow: 'hidden', whiteSpace: 'nowrap',
      }}
    >
      <Breadcrumbs separator="›" separatorMargin={6}>
        {stappen.map((stap, i) => {
          const laatste = i === stappen.length - 1;
          return laatste ? (
            <Text key={stap.niveau} size="sm" fw={600}>{stap.label}</Text>
          ) : (
            <Anchor key={stap.niveau} size="sm" onClick={() => naarNiveau(stap)}>
              {stap.label}
            </Anchor>
          );
        })}
      </Breadcrumbs>
    </Paper>
  );
}
